
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface VariantOptionsFiltersProps {
  factories: any[];
  variants: any[];
  filters: {
    factory: string;
    variant: string;
    optionName: string;
    optionValue: string;
    priceChange: string;
  };
  onFilterChange: (key: string, value: string) => void;
  onClearFilters: () => void;
  loading?: boolean;
}

export function VariantOptionsFilters({
  factories,
  variants,
  filters,
  onFilterChange,
  onClearFilters,
  loading = false
}: VariantOptionsFiltersProps) {
  const hasActiveFilters = Object.values(filters).some(value => value !== "" && value !== "all");

  return (
    <div className="bg-white p-4 rounded-lg border mb-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            className="flex items-center gap-2"
          >
            <X className="h-4 w-4" />
            Clear All
          </Button>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">Factory</label>
          <Select
            value={filters.factory || "all"}
            onValueChange={(value) => onFilterChange("factory", value === "all" ? "" : value)}
            disabled={loading}
          >
            <SelectTrigger>
              <SelectValue placeholder="All Factories" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Factories</SelectItem>
              {factories.map((factory) => (
                <SelectItem key={factory.id} value={factory.id}>
                  {factory.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Variant</label>
          <Select
            value={filters.variant || "all"}
            onValueChange={(value) => onFilterChange("variant", value === "all" ? "" : value)}
            disabled={loading}
          >
            <SelectTrigger>
              <SelectValue placeholder="All Variants" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Variants</SelectItem>
              {variants.map((variant) => (
                <SelectItem key={variant.id} value={variant.id}>
                  {variant.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Option Name</label>
          <Input
            placeholder="Filter by option name..."
            value={filters.optionName}
            onChange={(e) => onFilterChange("optionName", e.target.value)}
            disabled={loading}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Option Value</label>
          <Input
            placeholder="Filter by option value..."
            value={filters.optionValue}
            onChange={(e) => onFilterChange("optionValue", e.target.value)}
            disabled={loading}
          />
        </div>

        {/* <div className="space-y-2">
          <label className="text-sm font-medium">Price Change</label>
          <Select
            value={filters.priceChange || "all"}
            onValueChange={(value) => onFilterChange("priceChange", value === "all" ? "" : value)}
            disabled={loading}
          >
            <SelectTrigger>
              <SelectValue placeholder="All Prices" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Prices</SelectItem>
              <SelectItem value="positive">Positive (+)</SelectItem>
              <SelectItem value="negative">Negative (-)</SelectItem>
              <SelectItem value="zero">Zero (0)</SelectItem>
            </SelectContent>
          </Select>
        </div> */}
      </div>
    </div>
  );
}
